<div class="page-layout">
  <div class="export-msmt page-layout border-r-16" *transloco="let t">
    <div class="content">
      <div>
        <p>Rádi Vám pomůžeme s exportem pro MŠMT.</p>

        <p>V prvním kroku se ujistěte, že máte <strong>vyplněné všechny potřebné údaje</strong>:</p>
        <ul>
          <li>
            <a [routerLink]="links.kindergartenData()"><strong>Vaší organizace</strong></a> vč. informací o provozu
          </li>
          <li>
            <a [routerLink]="links.groups()"><strong>Jednotlivých tříd</strong></a>
          </li>
          <li>
            <a [routerLink]="links.children()"><strong>Všech dětí</strong></a>
            <ul>
              <li>
                Doporučení ŠPZ evidujte na profilu dítěte v záložce <strong>„Vzdělání a zdraví“</strong> skrze tlačítko
                <strong>„Zobrazit aktuální doporučení ŠPZ“</strong>
              </li>
              <li>
                Vykazovanou docházku předškoláků můžete spravovat v sekci
                <a [routerLink]="links.attendanceOverview()"><strong>„Přehled docházky“</strong></a> a speciálně po zvolení filtru
                <strong>„Pololetí - předškoláci“</strong>
              </li>
            </ul>
          </li>
        </ul>

        <p>
          Následně můžete vyzkoušet stáhnout export přes tlačítko
          <strong>„Exportovat pro MŠMT“</strong>, viz níže. Pokud naše aplikace odhalí chybějící povinné údaje, vypíše Vám chybu, kterou
          budete moci opravit.
        </p>

        <p>
          Když vše proběhne v pořádku, stáhne se Vám export zabalený ve formátu
          <strong>.ZIP</strong>. Kliknutím na něj by Vám mělo jít v počítači tento soubor rozbalit. V něm se nachází exportovaná data ve
          formátu <strong>.XML</strong>, jak je chce MŠMT.
        </p>

        <p>
          V případě, že při exportu či jeho nahrání do systému MŠMT narazíte na problémy, neváhejte se na nás obrátit:
          <a href="mailto:info@isophi.cz">info&#64;isophi.cz</a>
        </p>

        <p><strong>Společně vše vyřešíme!</strong></p>
      </div>
      <div class="row no-gutters">
        <div class="col text-center">
          <button (click)="exportData()" class="btn btn-lg btn-primary">{{ t('settings/exportData') }}</button>
        </div>
      </div>

      <div id="webinar" class="enrollment-transfer-card border-r-16" *transloco="let t">
        <div class="top-section mb-2">
          <div class="d-flex align-items-center justify-content-center">
            <span>Webinář na téma exportu (47 min.)</span>
          </div>
        </div>

        <div class="vimeo-wrapper">
          <div class="placeholder"></div>
          <iframe
            src="https://player.vimeo.com/video/1088729556?h=434b657285&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
            class="vimeo"
            title="Školení: Export z matriky pro MŠMT"
          ></iframe>
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>
      </div>
    </div>
  </div>
</div>

<ng-template #toastTemplate>
  <p class="mb-0" [innerHTML]="errorMessage"></p>
</ng-template>
